import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";

import {
  LOGIN,
  GET_USER,
  SEND_CODE,
  SEND_CODE_ON_EMAIL,
  VERIFY_CODE,
  LOGOUT,
  UPDATE_PROFILE,
  UPDATE_PASSWORD,
  MANAGE_REMIND,
  SEND_2FA_SETUP_CODE,
  REGISTRATION,
  SWITCH_ROLE,
  SWITCH_COMMITTEE,
  SET_PASSWORD
} from "./actions.type";
import {
  SET_AUTH,
  SET_LOADING,
  SET_PERMISSIONS,
  VERIFY_2FA_CODE,
  SET_ERROR,
  PURGE_AUTH,
  SET_SELECTED_COMMITTEE
} from "./mutations.type";

const AuthModule = {
    state: {
        errors: null,
        token: TokenService.getToken(),
        user: {},
        permissions: null,
        committeePermissions: {
          write: 0
        },
        twoFactorAuth: {},
        isLoading: true,
        committees: {},
        selectedCommittee : null
    },

    getters: {
        /**
         * Token is stored only if the 2FA has been completed
         * That is why relying on the local storage for checking
         * if the user is authenticated
         */
        isAuthenticated() {
            return !!TokenService.getToken();
        },
        getTwoFactorAuth(state) {
            return state.twoFactorAuth;
        },
        getUsername(state){
          return state.user.first_name ? state.user.first_name + ' ' + state.user.last_name:'';
        },
        getUser(state){
          return state.user;
        },
        getCommittees(state){
          return state.committees;
        },
        getSelectedCommittee(state){
          return state.selectedCommittee;
        }
    },

    actions: {
        [SET_LOADING](context) {
            context.commit( SET_LOADING );
        },
        [SWITCH_ROLE](context,role){
            TokenService.setCurrentRole(role)
        },
        [SWITCH_COMMITTEE](context,committee){
            context.commit( SET_SELECTED_COMMITTEE,committee);
        },
        [LOGIN](context, credentials) {
            return new Promise((resolve,reject) => {
                ApiService.post("/login", credentials)
                .then(response => {
                    context.commit( SET_AUTH, response.data );
                    resolve(response.data);
                })
                .catch(error => {
                    context.commit( SET_ERROR, (error.response && error.response.data && error.response.data.message) || error.message );
                    reject((error.response && error.response.data) || error);
                });
            });
        },
        async [GET_USER](context) {
            let res = {};
            await ApiService.get("/activeuser")
                .then(response => {
                    res = response.data.data;
                    context.commit( SET_PERMISSIONS, res );
                })
                .catch(error => {
                    // Destroy token and go to login page
                    context.commit( PURGE_AUTH );
                    res = {};
                });
            return res;
        },
        async [MANAGE_REMIND](context, remindMe) {
            let res = false;
            await ApiService.post('/twofactor/manageRemind', {remind_me: remindMe}).then(response => {
              TokenService.setToken(response.data.data.token,context.state.permissions);
              res = true;
            }).catch(error => {
              context.commit( SET_ERROR, error.response.data.message );
              res = false;
            });
            return res;
        },
        async [VERIFY_CODE](context, requestData) {
            let res = false;

            await ApiService.post('/twofactor/verify', requestData).then(response => {
              TokenService.setToken(response.data.data.token,context.state.permissions);
              TokenService.setRememberMeCookie(context.state.user.email, response.data.data.rememberMeId);
              res = true;
            }).catch(error => {
              context.commit( SET_ERROR, 'Invalid token. Try again!' );
              res = false;
            });
            return res;
        },
        async [SEND_2FA_SETUP_CODE](context, twoFASetUpData) {
            let res = false;
            await ApiService.post('/twofactor/send2fasetupcode', {data: twoFASetUpData}).then(response => {
              context.state.twoFactorAuth.tf_mobile_number = response.data.data.tf_mobile_number;
              res = true;
            }).catch(error => {
              context.commit( SET_ERROR, 'Invalid token. Try again!' );
              res = false;
            });
            return res;
        },
        [SEND_CODE](context) {
            return new Promise( resolve => {
                ApiService.get("/twofactor/sendSms")
                .then(({ data }) => {

                })
                .catch(({ response }) => {

                })
            });
        },
        [SEND_CODE_ON_EMAIL](context) {
          return new Promise( resolve => {
              ApiService.get("/twofactor/send2faCodeOnEmail")
              .then(({ data }) => {
                resolve(true)
              })
              .catch(({ response }) => {
                reject(false);
              })
          });
        },
        [LOGOUT](context) {
          return new Promise( resolve => {
                ApiService.get("logout")
                .then(({ data }) => {
                  TokenService.removeToken();
                  resolve('logged-out');
                });
            });
        },
        [UPDATE_PROFILE](context,payload){
            return new Promise((resolve,reject) => {
              ApiService.post("/user-requests",payload.params)
                .then(({ data }) => {
                  resolve(data);
                })
                .catch(({ response }) => {
                  reject(response)
                })
            });
        },
        [UPDATE_PASSWORD](context,payload){
          return new Promise((resolve,reject) => {
            ApiService.post("/change-password",payload)
              .then(({ data }) => {
                resolve(data);
              })
              .catch(({ response }) => {
                reject(response)
              })
          });
        },
      [SET_PASSWORD](context,payload){
        return new Promise((resolve,reject) => {
          ApiService.post(payload[0],{password: payload[1]})
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              reject(response)
            })
        });
      },
        async [REGISTRATION](context,payload){
          let res = {};
          await ApiService.post('/register',payload)
            .then(response =>{
              context.commit(SET_ERROR,null);
              res = response.data;
            })
            .catch(error => {
              res = error.response.data;
            });
          return res;
        }
    },

    mutations: {
        [SET_LOADING](state) {
            state.isLoading = true;
        },

        [SET_ERROR](state, error) {
            state.errors = error;
            state.isLoading = false;
        },

        [SET_AUTH](state, response) {
            const data = response.data;
            state.token = data.token;

            state.user = data.user;
            state.permissions = data.permissions;
            state.committeePermissions = data.committeePermissions;
            state.committees = data.committees;
            state.selectedCommittee = state.committees.length > 0 ? state.committees[0].id:null;

            state.twoFactorAuth = data["2fa_setup"];
            state.errors = null;


            state.isLoading = false;
        },

        [SET_PERMISSIONS](state, data) {
            state.user = data.user;
            state.permissions = data.permissions;
            state.committeePermissions = data.committeePermissions;
            state.committees = data.committees;
            state.selectedCommittee = (state.committees.length > 0 && state.selectedCommittee === null)? state.committees[0].id:null;

            state.errors = null;
            state.isLoading = false;
        },

        [VERIFY_2FA_CODE](state, data) {
            // only store the token in local storage once we know that the auth has been completed
            state.twoFactorAuth.completed = true;
            TokenService.setToken(state.token);
            state.isLoading = false;
        },

        [PURGE_AUTH](state) {
            state.twoFactorAuth = {};
            TokenService.removeToken();
            state.isLoading = false;
        },

        [SET_SELECTED_COMMITTEE](state,data){
          state.selectedCommittee = data;
        },
    }
}

export default AuthModule;
